var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100 mt-5 align-self-center text-center"},[_c('navbar'),_c('p',[_vm._v("...")]),_c('footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }